import XDate from 'xdate'

import {
  QuickPassSharePage,
  QuickPassSharePageVisibility,
} from '../../_types/quickpass-share-page'

const PUBLIC_BASE_URL = 'https://app.quickpass.club'

/**
 * Builds the shareable URL for a renter pass. Returns the public origin
 * in production builds, falls back to the current page origin in dev
 * (so the renter can copy a working localhost link while testing).
 *
 * @param {QuickPassSharePage} page
 * @returns {string}
 */
const buildShareLink = (page: QuickPassSharePage): string => {
  const origin =
    typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    window.location.origin.startsWith('http://localhost')
      ? window.location.origin
      : PUBLIC_BASE_URL
  return `${origin}/#/me/${page.slug}?k=${page.shareToken}`
}

const formatLastViewed = (timestamp: number | null): string => {
  if (timestamp === null || timestamp <= 0) return 'No views yet'
  return `Last viewed ${new XDate(timestamp).toString("MMM d 'at' h:mm TT")}`
}

const VISIBILITY_LABELS: Array<{
  key: keyof QuickPassSharePageVisibility
  label: string
  description: string
}> = [
  {
    key: 'showContact',
    label: 'Contact info',
    description: 'Your email and phone — landlords need this to reach out.',
  },
  {
    key: 'showPreferences',
    label: 'What I’m looking for',
    description: 'Cities, budget, bedrooms, place type. Recommended on.',
  },
  {
    key: 'showAboutMe',
    label: 'About me',
    description:
      'Your renter narrative paragraphs from your QuickPass profile.',
  },
  {
    key: 'showSavedCount',
    label: 'Saved-places count',
    description: 'Social proof — shows you’re actively exploring.',
  },
  {
    key: 'showMoveInDate',
    label: 'Move-in date',
    description: 'When you’re hoping to move. Helps with planning.',
  },
  {
    key: 'showAuthProviders',
    label: 'Sign-in verifications',
    description: 'Shows whether your email / Google is verified.',
  },
  {
    key: 'showVerifications',
    label: 'Verified badges',
    description:
      'Government ID and other verifications you’ve completed. Strong trust signal — recommended on.',
  },
  {
    key: 'showIncome',
    label: 'Monthly income',
    description:
      'Off by default — only enable if you want landlords to see this upfront.',
  },
]

export { PUBLIC_BASE_URL, buildShareLink, formatLastViewed, VISIBILITY_LABELS }
